import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  mutationOptions,
  withError,
  withInvalidate,
} from '@/react-tools/react-query';
import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { environmentQueryKeys } from '@/react/portainer/environments/queries/query-keys';

import { PolicyId, TypedPolicy } from '../types';

import { queryKeys } from './query-keys';
import { UpdatePolicyPayload } from './types';

export function useUpdatePolicyMutation() {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, payload }: { id: PolicyId; payload: UpdatePolicyPayload }) =>
      updatePolicy(id, payload),
    mutationOptions(
      // invalidating base key triggers refetch for both list and detail (needed for computed StatusBreakdown)
      // invalidate environments so applied policies for environments are refreshed
      withInvalidate(queryClient, [
        queryKeys.base,
        environmentQueryKeys.base(),
      ]),
      withError('Unable to update policy')
    )
  );
}

async function updatePolicy(
  id: PolicyId,
  payload: UpdatePolicyPayload
): Promise<TypedPolicy<unknown>> {
  try {
    const { data } = await axios.put<TypedPolicy<unknown>>(
      `/policies/${id}`,
      payload
    );
    return data;
  } catch (error) {
    throw parseAxiosError(error, 'Unable to update policy');
  }
}
